import { OrganizationUserType } from '@mfw/common';

import { useOrganizationContext, useAuthContext } from '../context';
import useLogicalProfiles from './users/useLogicalProfiles';

// F1.2/F1.3 — the top-level personal HOME is unconditionally visible in
// personal (B2C) mode, but inside a single-org B2B context it would just
// duplicate that org's own Org Home — so there it only shows once the user is
// juggling 2+ B2B profiles. Stay visible while logical profiles are still
// loading to avoid a show-then-hide flash.
//
// T1 — this no longer gates the personal CALENDAR entry, which now has its own
// condition in `SidebarContent`: the calendar the personal profile writes into
// must stay reachable in a single-org B2B context too. What still depends on
// this hook is the Home entry and `DashboardPage`'s redirect to Marketplace
// (a page with no matching nav entry), so its return value must not widen.
//
// The CLIENT branch is kept for the Home entry, but NOT for the reason once
// written here: clients DO hold `trainers_read`/`users_read` (both are in the
// `client` role, seeder and baseline alike). It survives because a client has
// no Org Home worth duplicating, not because of a permission they lack.
export default function useShowTopHomeCalendar() {
  const { currentUser } = useAuthContext();
  const { isPersonalMode, currentOrgUser } = useOrganizationContext();
  const logicalProfiles = useLogicalProfiles(!currentUser?.isPlatformUser);
  const b2bProfileCount = logicalProfiles.data?.filter(
    (profile) => profile.context === 'B2B',
  ).length;

  return (
    isPersonalMode ||
    currentOrgUser?.type === OrganizationUserType.CLIENT ||
    b2bProfileCount === undefined ||
    b2bProfileCount >= 2
  );
}
